/**
 * Created by matheusmorett on 11/17/17.
 */
import axios from 'axios';
import querystring from 'querystring';

class Api {

  constructor() {
    this.baseURL = process.env.REACT_APP_API_URL;
    // this.baseURL = 'http://localhost:8888/adrenalyze-back/api/web/v1';
    // this.baseURL = 'http://localhost:8888/Adrenalyze/adrenalyze-back/api/web/v1';
    // this.baseURL = 'http://192.168.1.108:8888/adrenalyze-back/api/web/v1';
    // this.baseURL = 'http://192.168.0.26:8888/adrenalyze-back/api/web/v1';
    this.call = this.call.bind(this);
  }

  call(url, method, params = {}, image = false, json = false, progressCalback = () => { }) {

    if (method === 'get') {
      const getParams = [];
      Object.keys(params).map((key) => getParams.push(key + '=' + params[key]));

      if (getParams.length) {
        url += '?' + getParams.join('&');
      }
      params = {};
    }

    let contentType = 'application/x-www-form-urlencoded';

    if (json === true) {
      contentType = 'application/json';
    }

    if (image) {
      contentType = 'multipart/form-data';
    }

    return axios({
      url: url,
      method: method,
      baseURL: this.baseURL,
      headers: {
        'accept': 'application/json',
        'Content-Type': contentType,
        'Authorization': this.getAuthorization()
      },
      onUploadProgress: (progressEvent) => progressCalback(Math.floor((progressEvent.loaded * 80) / progressEvent.total)),
      onDownloadProgress: (progressEvent) => progressCalback(80 + Math.floor((progressEvent.loaded * 20) / progressEvent.total)),
      data: (json === true || image === true) ? params : querystring.stringify(params)
    })
      .then(response => response)
      .catch(error => {

        if (error.response && error.response.status === 401) { // Se for erro de autorizacao, atualizar sessao
          localStorage.clear()
          return null;

        }

        throw error.response.data;
      });
  };

  getAuthorization() {
    const user = JSON.parse(localStorage.getItem('user'));
    if (!!user) {
      return user.auth_key
    }
  }
}


export default new Api();



// WEBPACK FOOTER //
// ./src/utils/Api.js